module.exports = __webpack_public_path__ + "static/media/browser-not-available.674cebcd.svg";